import React from 'react'
import { useSelector } from 'react-redux'
import Instructions from './components/Instructions'
import CTAScreen from '../CTAScreen'
import RenderSelector from './components/RenderSelector'
import '../../styles/components/ModelSelector.scss'
import NextScreen from './components/NextScreen'
import minilogo from '../../assets/Images/stream-mini-logo.png'

const ModelSelector = () => {
  const { questions } = useSelector((state) => state.models)

  return (
    <>
      <div className="logo">
        <img src={minilogo} alt="Stream logo" />
      </div>
      <div className="ModelSelector" data-testid="ModelSelector">
        <Instructions />
        <RenderSelector />
        <NextScreen />
        {questions === 5 && <CTAScreen />}
      </div>
    </>
  )
}

export default ModelSelector
